module.exports = __webpack_public_path__ + "img/marcas.86b9eadf.png";